module.exports = {
      id: "dec-usage",
      viewBox: "0 0 8 2",
      url: __webpack_public_path__ + "sprite-99dfb162d59834e1e55e619b64a45f56.svg#dec",
      toString: function () {
        return this.url;
      }
    }